import React from 'react';
import PropTypes from 'prop-types';
import {Box} from 'views/components';
import {Translate} from 'views/module';

const StatusTag = (props) => {
  const {userIdentity} = props;
  if (!userIdentity) {
    return (
      <Box
        component="span"
        sx={{
          px: 1,
          py: 0.25,
          bgcolor: 'error.main',
          color: 'white',
          borderRadius: 3,
          fontSize: '12px',
          display: 'inline-flex',
          alignItems: 'center',
        }}
      >
        <Translate expression='client.ClientDetail.Relationships.Authentication.NotAuthenticated' />
      </Box>
    );
  }
  if (userIdentity.status === 'ACTIVE') {
    return (
      <Box
        component="span"
        sx={{
          px: 1,
          py: 0.25,
          bgcolor: 'success.main',
          color: 'white',
          borderRadius: 3,
          fontSize: '12px',
          display: 'inline-flex',
          alignItems: 'center',
        }}
      >
        <Translate expression='client.ClientDetail.Relationships.Authentication.Active' />
      </Box>
    );
  } else if (userIdentity.status === 'INACTIVE') {
    return (
      <Box
        component="span"
        sx={{
          px: 1,
          py: 0.25,
          bgcolor: 'grey.500',
          color: 'white',
          borderRadius: 3,
          fontSize: '12px',
          display: 'inline-flex',
          alignItems: 'center',
        }}
      >
        <Translate expression='client.ClientDetail.Relationships.Authentication.Inactive' />
      </Box>
    );
  }

  return null;
};

StatusTag.propTypes = {
  userIdentity: PropTypes.shape({
    status: PropTypes.string,
  }),
};

export default StatusTag;
